import api from './api';

/**
 * Permissions Service - جلب صلاحيات المستخدم بناءً على اشتراكه
 */
const permissionsService = {
  /**
   * Get current user's permissions based on their subscription
   * @returns {Promise} User permissions object
   */
  async getMyPermissions() {
    try {
      const response = await api.get('/user/permissions');
      return response;
    } catch (error) {
      console.error('Error fetching permissions:', error);
      throw error;
    }
  },

  /**
   * Check if user has access to a specific feature
   * @param {string} featureCode - The feature code to check
   * @returns {Promise} Access check result
   */
  async checkPermission(featureCode) {
    try {
      const response = await api.post('/user/permissions/check', { featureCode });
      return response;
    } catch (error) {
      console.error('Error checking permission:', error);
      throw error;
    }
  }
};

export default permissionsService;
